export const defaultResponse = `
  messages {
    error
    success
  }
  status
  http_code
`;
